export const useIsPrint = createGlobalState(() => useMediaQuery('print'))
